import { render, staticRenderFns } from "./ManageDashboardButtons.vue?vue&type=template&id=5f8ea11e&scoped=true"
import script from "./ManageDashboardButtons.vue?vue&type=script&lang=js"
export * from "./ManageDashboardButtons.vue?vue&type=script&lang=js"
import style0 from "./ManageDashboardButtons.vue?vue&type=style&index=0&id=5f8ea11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ea11e",
  null
  
)

export default component.exports